import { SampleSerieType, SampleCollectionLocation } from './samples.types';

export enum SequencedSampleSerieStatus {
  RECOLLECT = 'RECOLLECT',
  SEQUENCING_COMPLETE = 'SEQUENCING_COMPLETE',
  RESULTS_DELIVERED = 'RESULTS_DELIVERED',
  VALID = 'VALID',
}

export interface SequencedSamplesSeries {
  collectionLocation: SampleCollectionLocation;
  status: SequencedSampleSerieStatus;
  groupValue: string;
  type: SampleSerieType;
  value: number;
}

export interface SequencedDataPercentChanges {
  collectionLocation: SampleCollectionLocation;
  value: number | null;
}

export interface SequencedDataStats {
  percentChanges: SequencedDataPercentChanges[];
}

export interface SequencedSamples {
  series: SequencedSamplesSeries[];
  stats: SequencedDataStats;
}

export interface FetchSequencedSamplesOverviewParam {
  studyId?: string;
  endDate?: Date;
}
